import { useAuth } from '@context/auth';
import { AccessTokenResponseDto, ImpersonatorAccount } from '@givz/core-client';
import {
  Autocomplete,
  TextField,
  Typography,
  UseAutocompleteProps,
} from '@mui/material';
import { Stack } from '@mui/system';
import {
  useImpersonate,
  useImpersonatorListAccounts,
} from '@queries/impersonator';
import { FunctionComponent, useEffect, useState } from 'react';

export const Impersonator: FunctionComponent = () => {
  const { impersonate } = useAuth();
  const [{ data }, setSearch] = useImpersonatorListAccounts();
  const { mutate } = useImpersonate({ onSuccess: onImpersonatorSuccess });
  const [impersonatorAccount, setImpersonatorAccount] =
    useState<ImpersonatorAccount>();

  useEffect(() => {
    if (impersonatorAccount) {
      mutate({
        impersonatorImpersonateDto: {
          targetAccountGid: impersonatorAccount.gid,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [impersonatorAccount]);

  const onChange: UseAutocompleteProps<
    ImpersonatorAccount,
    undefined,
    undefined,
    undefined
  >['onChange'] = (_event, value) => {
    if (value) {
      setImpersonatorAccount(value);
    }
  };

  const onInputChange: UseAutocompleteProps<
    string,
    undefined,
    undefined,
    undefined
  >['onInputChange'] = (_event, value) => {
    if (value?.length > 2) {
      setSearch({ q: value });
    }
  };

  function onImpersonatorSuccess(accessToken: AccessTokenResponseDto) {
    if (impersonatorAccount) {
      impersonate({
        accessToken: accessToken.accessToken,
        account: impersonatorAccount,
      });
    }
  }

  return (
    <Stack spacing={2}>
      <Typography variant="h4">Select an account to impersonate</Typography>
      <Autocomplete
        disablePortal
        id="impersonator-search"
        getOptionLabel={(option) => option.name}
        options={data?.data?.accounts ?? []}
        renderInput={(params) => (
          <TextField {...params} label="Impersonate Account" />
        )}
        onChange={onChange}
        onInputChange={onInputChange}
      />
    </Stack>
  );
};
